<template>
  <div class="toolbar-container">
    <div class="left-toolbar">
      <el-button type="primary" link :disabled="undoDisabled" size="small" :title="i18nt('designer.toolbar.undoHint')" @click="undoHistory"> <svg-icon icon-class="undo" /></el-button>
      <el-button type="primary" link :disabled="redoDisabled" size="small" :title="i18nt('designer.toolbar.redoHint')" @click="redoHistory"> <svg-icon icon-class="redo" /></el-button>
      <el-button-group style="margin-left: 20px">
        <!-- <el-button :type="layoutType === 'PC' ? 'info' : ''" @click="changeLayoutType('PC')"> {{ i18nt('designer.toolbar.pcLayout') }}</el-button> -->
        <el-button :type="layoutType === 'Pad' ? 'info' : ''" @click="changeLayoutType('Pad')"> {{ i18nt('designer.toolbar.padLayout') }}</el-button>
        <el-button :type="layoutType === 'H5' ? 'info' : ''" @click="changeLayoutType('H5')"> {{ i18nt('designer.toolbar.mobileLayout') }}</el-button>
      </el-button-group>
      <el-button style="margin-left: 20px" :title="i18nt('designer.toolbar.nodeTreeHint')" @click="showNodeTreeDrawer"> <svg-icon icon-class="node-tree" /></el-button>
    </div>

    <el-drawer
      :title="i18nt('designer.toolbar.nodeTreeTitle')"
      direction="ltr"
      v-model="showNodeTreeDrawerFlag"
      :modal="true"
      :size="280"
      append-to-body
      :destroy-on-close="true"
      class="node-tree-drawer"
    >
      <el-tree ref="nodeTree" :data="nodeTreeData" node-key="id" default-expand-all highlight-current class="node-tree" icon-class="el-icon-arrow-right" @node-click="onNodeTreeClick"></el-tree>
    </el-drawer>

    <div class="right-toolbar">
      <div class="right-toolbar-con">
        <el-button v-if="showToolButton('clearDesignerButton')" type="primary" link @click="clearFormWidget"> <svg-icon icon-class="el-delete" />{{ i18nt('designer.toolbar.clear') }}</el-button>
        <el-button v-if="showToolButton('previewFormButton')" type="primary" link @click="previewForm"> <svg-icon icon-class="el-view" />{{ i18nt('designer.toolbar.preview') }}</el-button>
        <el-button v-if="showToolButton('importJsonButton')" type="primary" link @click="importJson"> {{ i18nt('designer.toolbar.importJson') }}</el-button>
        <el-button v-if="showToolButton('exportJsonButton')" type="primary" link @click="exportJson"> {{ i18nt('designer.toolbar.exportJson') }}</el-button>
        <el-button v-if="showToolButton('exportCodeButton')" type="primary" link @click="exportCode"> {{ i18nt('designer.toolbar.exportCode') }}</el-button>
        <slot name="customToolButtons"></slot>
      </div>
    </div>

    <div v-if="showPreviewDialogFlag" class="" v-drag="['.drag-dialog.el-dialog', '.drag-dialog .el-dialog__header']">
      <el-dialog
        :title="i18nt('designer.toolbar.preview')"
        v-model="showPreviewDialogFlag"
        :show-close="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
        :destroy-on-close="true"
        :append-to-body="true"
        class="drag-dialog small-padding-dialog"
        width="75%"
        :fullscreen="layoutType === 'H5' || layoutType === 'Pad'"
      >
        <div>
          <div class="form-render-wrapper" :class="[layoutType === 'H5' ? 'h5-layout' : layoutType === 'Pad' ? 'pad-layout' : '']">
            <VmFormRender
              ref="preForm"
              :form-json="formJson"
              :form-data="testFormData"
              :preview-state="true"
              :option-data="testOptionData"
              :global-dsv="designerDsv"
              @appendButtonClick="testOnAppendButtonClick"
              @buttonClick="testOnButtonClick"
              @dataTableSelectionChange="testDTSC"
              @operationButtonClick="testOBC"
              @myEmitTest="onMyEmitTest"
              @formChange="handleFormChange"
            >
              <template v-for="(idx, slotName) in $slots" v-slot:[slotName]="scope">
                <slot :name="slotName" v-bind="scope"></slot>
              </template>
            </VmFormRender>
          </div>
        </div>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="getFormData">{{ i18nt('designer.hint.getFormData') }}</el-button>
            <el-button type="primary" @click="resetForm">{{ i18nt('designer.hint.resetForm') }}</el-button>
            <el-button type="primary" @click="setFormDisabled">{{ i18nt('designer.hint.disableForm') }}</el-button>
            <el-button type="primary" @click="setFormEnabled">{{ i18nt('designer.hint.enableForm') }}</el-button>
            <el-button type="primary" plain @click="switchReadMode">{{ i18nt('designer.hint.switchReadMode') }}</el-button>
            <el-button @click="showPreviewDialogFlag = false">{{ i18nt('designer.hint.closePreview') }}</el-button>
            <el-button v-if="false" @click="testSetFormJson">setFormJson</el-button>
            <el-button v-if="false" @click="testSubFormHide">Test SFH</el-button>
            <el-button v-if="false" @click="testSetFormData">Test SFD</el-button>
          </div>
        </template>
      </el-dialog>
    </div>

    <div v-if="showImportJsonDialogFlag" class="" v-drag="['.drag-dialog.el-dialog', '.drag-dialog .el-dialog__header']">
      <el-dialog
        :title="i18nt('designer.toolbar.importJson')"
        v-model="showImportJsonDialogFlag"
        :show-close="true"
        class="drag-dialog small-padding-dialog"
        :append-to-body="true"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
      >
        <el-alert type="info" :title="i18nt('designer.hint.importJsonHint')" show-icon class="alert-padding"></el-alert>
        <code-editor :mode="'json'" :readonly="false" v-model="importTemplate"></code-editor>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="doJsonImport"> {{ i18nt('designer.hint.import') }}</el-button>
            <el-button @click="showImportJsonDialogFlag = false"> {{ i18nt('designer.hint.cancel') }}</el-button>
          </div>
        </template>
      </el-dialog>
    </div>

    <div v-if="showExportJsonDialogFlag" class="" v-drag="['.drag-dialog.el-dialog', '.drag-dialog .el-dialog__header']">
      <el-dialog
        :title="i18nt('designer.toolbar.exportJson')"
        v-model="showExportJsonDialogFlag"
        :show-close="true"
        class="drag-dialog small-padding-dialog"
        center
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
      >
        <code-editor :mode="'json'" :readonly="true" v-model="jsonContent"></code-editor>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" class="copy-json-btn" :data-clipboard-text="jsonRawContent" @click="copyFormJson"> {{ i18nt('designer.hint.copyJson') }}</el-button>
            <el-button @click="saveFormJson">{{ i18nt('designer.hint.saveFormJson') }}</el-button>
            <el-button @click="showExportJsonDialogFlag = false"> {{ i18nt('designer.hint.closePreview') }}</el-button>
          </div>
        </template>
      </el-dialog>
    </div>

    <div v-if="showExportCodeDialogFlag" class="" v-drag="['.drag-dialog.el-dialog', '.drag-dialog .el-dialog__header']">
      <el-dialog
        :title="i18nt('designer.toolbar.exportCode')"
        v-model="showExportCodeDialogFlag"
        :show-close="true"
        class="drag-dialog small-padding-dialog"
        center
        append-to-body
        width="65%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
      >
        <el-tabs type="border-card" class="no-box-shadow no-padding" v-model="activeCodeTab">
          <el-tab-pane label="Vue" name="vue">
            <code-editor :mode="'html'" :readonly="true" v-model="vueCode" :user-worker="false"></code-editor>
          </el-tab-pane>
          <el-tab-pane label="HTML" name="html">
            <code-editor :mode="'html'" :readonly="true" v-model="htmlCode" :user-worker="false"></code-editor>
          </el-tab-pane>
        </el-tabs>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" class="copy-vue-btn" :data-clipboard-text="vueCode" @click="copyVueCode"> {{ i18nt('designer.hint.copyVueCode') }}</el-button>
            <el-button type="primary" class="copy-html-btn" :data-clipboard-text="htmlCode" @click="copyHtmlCode"> {{ i18nt('designer.hint.copyHtmlCode') }}</el-button>
            <el-button @click="saveVueCode">{{ i18nt('designer.hint.saveVueCode') }}</el-button>
            <el-button @click="saveHtmlCode">{{ i18nt('designer.hint.saveHtmlCode') }}</el-button>
            <el-button @click="showExportCodeDialogFlag = false"> {{ i18nt('designer.hint.closePreview') }}</el-button>
          </div>
        </template>
      </el-dialog>
    </div>

    <div v-if="showFormDataDialogFlag" class="" v-drag="['.nested-drag-dialog.el-dialog', '.nested-drag-dialog .el-dialog__header']">
      <el-dialog
        :title="i18nt('designer.hint.exportFormData')"
        v-model="showFormDataDialogFlag"
        :show-close="true"
        class="nested-drag-dialog dialog-title-light-bg"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :append-to-body="true"
      >
        <div style="border: 1px solid #dcdfe6">
          <code-editor :mode="'json'" :readonly="true" v-model="formDataJson"></code-editor>
        </div>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" class="copy-form-data-json-btn" :data-clipboard-text="formDataRawJson" @click="copyFormDataJson"> {{ i18nt('designer.hint.copyFormData') }}</el-button>
            <el-button @click="saveFormData">{{ i18nt('designer.hint.saveFormData') }}</el-button>
            <el-button @click="showFormDataDialogFlag = false"> {{ i18nt('designer.hint.closePreview') }}</el-button>
          </div>
        </template>
      </el-dialog>
    </div>

    <div v-if="showExportSFCDialogFlag" class="" v-drag="['.drag-dialog.el-dialog', '.drag-dialog .el-dialog__header']">
      <el-dialog
        :title="i18nt('designer.toolbar.generateSFC')"
        v-model="showExportSFCDialogFlag"
        append-to-body
        v-if="showExportSFCDialogFlag"
        :show-close="true"
        class="drag-dialog small-padding-dialog"
        center
        width="65%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
      >
        <el-tabs type="border-card" class="no-box-shadow no-padding" v-model="activeSFCTab">
          <el-tab-pane label="Vue2" name="vue2">
            <code-editor :mode="'html'" :readonly="true" v-model="sfcCode" :user-worker="false"></code-editor>
          </el-tab-pane>
          <el-tab-pane label="Vue3" name="vue3">
            <code-editor :mode="'html'" :readonly="true" v-model="sfcCodeV3" :user-worker="false"></code-editor>
          </el-tab-pane>
        </el-tabs>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" class="copy-vue2-sfc-btn" :data-clipboard-text="sfcCode" @click="copyV2SFC"> {{ i18nt('designer.hint.copyVue2SFC') }}</el-button>
            <el-button type="primary" class="copy-vue3-sfc-btn" :data-clipboard-text="sfcCodeV3" @click="copyV3SFC"> {{ i18nt('designer.hint.copyVue3SFC') }}</el-button>
            <el-button @click="saveV2SFC">{{ i18nt('designer.hint.saveVue2SFC') }}</el-button>
            <el-button @click="saveV3SFC">{{ i18nt('designer.hint.saveVue3SFC') }}</el-button>
            <el-button @click="showExportSFCDialogFlag = false"> {{ i18nt('designer.hint.closePreview') }}</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, nextTick, ref, toRefs, reactive, inject, computed, onMounted } from 'vue';

import VmFormRender from '@/components/form-render/index';
import CodeEditor from '@/components/code-editor/index';
import SvgIcon from '@/components/svg-icon';
import Clipboard from 'clipboard';
import { deepClone, copyToClipboard, generateId, getQueryParam, traverseAllWidgets, addWindowResizeHandler } from '@/utils/util';
import { useI18n } from '@/utils/i18n';
import { generateCode } from '@/utils/code-generator';
import { genSFC } from '@/utils/sfc-generator';
import loadBeautifier from '@/utils/beautifierLoader';
import { saveAs } from 'file-saver';

export default {
  components: {
    Clipboard,
    CodeEditor,
    SvgIcon,
    VmFormRender,
  },
  name: 'ToolbarPanel',
  props: {
    designer: Object,
    globalDsv: {
      default: () => ({}),
      type: Object,
    },
  },
  setup(props) {
    const { i18nt } = useI18n();

    const { proxy } = getCurrentInstance();
    let $current = proxy;

    const getDesignerConfig = inject('getDesignerConfig');

    /* 页面组件 */
    const nodeTree = ref(null);
    const preForm = ref(null);

    const data = reactive({
      activeCodeTab: 'vue',

      activeSFCTab: 'vue2',
      designerConfig: getDesignerConfig(),
      formDataJson: '',
      formDataRawJson: '',
      formReadonlyFlag: false,
      htmlCode: '',
      importTemplate: '',
      jsonContent: '',

      jsonRawContent: '',
      nodeTreeData: [],

      sfcCode: '',
      sfcCodeV3: '',
      showExportCodeDialogFlag: false,

      showExportJsonDialogFlag: false,
      showExportSFCDialogFlag: false,

      showFormDataDialogFlag: false,
      showImportJsonDialogFlag: false,

      showNodeTreeDrawerFlag: false,
      showPreviewDialogFlag: false,

      testFormData: {
        // 'userName': '666888',
        // 'productItems': [
        //   {'pName': 'iPhone12', 'pNum': 10},
        //   {'pName': 'P50', 'pNum': 16},
        // ]

        select62173: 2,
      },
      testOptionData: {
        // 'select62173': [
        //   {label: '01', value: 1},
        //   {label: '22', value: 2},
        //   {label: '333', value: 3},
        // ]
      },

      toolbarWidth: 420,
      vueCode: '',
    });

    onMounted(() => {});

    const formJson = computed(() => {
      return {
        formConfig: deepClone(props.designer.formConfig),
        widgetList: deepClone(props.designer.widgetList),
      };
    });

    const undoDisabled = computed(() => {
      return !props.designer.undoEnabled();
    });

    const redoDisabled = computed(() => {
      return !props.designer.redoEnabled();
    });

    const layoutType = computed(() => {
      return props.designer.getLayoutType();
    });

    const designerDsv = computed(() => {
      return props.globalDsv;
    });

    const showToolButton = configName => {
      if (data.designerConfig[configName] === undefined) {
        return true;
      }
      return !!data.designerConfig[configName];
    };

    const buildTreeNodeOfWidget = (widget, treeNode) => {
      let curNode = {
        id: widget.id,
        label: widget.options.label || widget.type,
        // selectable: true,
      };
      treeNode.push(curNode);

      if (widget.category === undefined) {
        return;
      }

      curNode.children = [];
      if (widget.type === 'm-grid') {
        widget.cols.map(col => {
          let colNode = {
            children: [],
            id: col.id,
            label: col.options.name || widget.type,
          };
          curNode.children.push(colNode);
          col.widgetList.map(wChild => {
            buildTreeNodeOfWidget(wChild, colNode.children);
          });
        });
      } else if (widget.type === 'm-table') {
        // TODO: 需要考虑合并单元格！！
        widget.rows.map(row => {
          let rowNode = {
            children: [],
            id: row.id,
            label: 'table-row',
            selectable: false,
          };
          curNode.children.push(rowNode);

          row.cols.map(cell => {
            if (cell.merged) {
              // 跳过合并单元格！！
              return;
            }

            let rowChildren = rowNode.children;
            let cellNode = {
              children: [],
              id: cell.id,
              label: 'm-table-cell',
            };
            rowChildren.push(cellNode);

            cell.widgetList.map(wChild => {
              buildTreeNodeOfWidget(wChild, cellNode.children);
            });
          });
        });
      } else if (widget.type === 'm-tab') {
        widget.tabs.map(tab => {
          let tabNode = {
            children: [],
            id: tab.id,
            label: tab.options.name || widget.type,
            selectable: false,
          };
          curNode.children.push(tabNode);
          tab.widgetList.map(wChild => {
            buildTreeNodeOfWidget(wChild, tabNode.children);
          });
        });
      } else if (widget.type === 'm-sub-form') {
        widget.widgetList.map(wChild => {
          buildTreeNodeOfWidget(wChild, curNode.children);
        });
      } else if (widget.category === 'container') {
        // 自定义容器
        widget.widgetList.map(wChild => {
          buildTreeNodeOfWidget(wChild, curNode.children);
        });
      }
    };

    const refreshNodeTree = () => {
      data.nodeTreeData.length = 0;
      props.designer.widgetList.forEach(wItem => {
        buildTreeNodeOfWidget(wItem, data.nodeTreeData);
      });
    };

    const showNodeTreeDrawer = () => {
      refreshNodeTree();
      data.showNodeTreeDrawerFlag = true;
      nextTick(() => {
        if (props.designer.selectedId) {
          // 同步当前选中组件到节点树！！！
          nodeTree.value.setCurrentKey(props.designer.selectedId);
        }
      });
    };

    const undoHistory = () => {
      props.designer.undoHistoryStep();
    };

    const redoHistory = () => {
      props.designer.redoHistoryStep();
    };

    const changeLayoutType = newType => {
      props.designer.changeLayoutType(newType);
    };

    const clearFormWidget = () => {
      props.designer.clearDesigner();
    };

    const previewForm = () => {
      formJson.value.widgetList = deepClone(props.designer.widgetList);
      formJson.value.formConfig = deepClone(props.designer.formConfig);

      data.showPreviewDialogFlag = true;
    };

    const saveAsFile = (fileContent, defaultFileName) => {
      $current
        .$prompt(i18nt('designer.hint.fileNameForSave'), i18nt('designer.hint.saveFileTitle'), {
          closeOnClickModal: false,
          inputPlaceholder: i18nt('designer.hint.fileNameInputPlaceholder'),
          inputValue: defaultFileName,
        })
        .then(({ value }) => {
          if (!value) {
            value = defaultFileName;
          }

          if (getQueryParam('vscode') === 1) {
            vsSaveFile(value, fileContent);
            return;
          }

          const fileBlob = new Blob([fileContent], { type: 'text/plain;charset=utf-8' });
          saveAs(fileBlob, value);
        })
        .catch(() => {
          //
        });
    };

    const vsSaveFile = (fileName, fileContent) => {
      const msgObj = {
        cmd: 'writeFile',
        data: {
          code: fileContent,
          fileName,
        },
      };
      window.parent.postMessage(msgObj, '*');
    };

    const importJson = () => {
      data.importTemplate = JSON.stringify(props.designer.getImportTemplate(), null, '  ');
      data.showImportJsonDialogFlag = true;
    };

    const doJsonImport = () => {
      try {
        let importObj = JSON.parse(data.importTemplate);
        // console.log('test import', this.importTemplate)
        if (!importObj || !importObj.formConfig) {
          throw new Error(i18nt('designer.hint.invalidJsonFormat'));
        }

        let fJsonVer = importObj.formConfig.jsonVersion;
        if (!fJsonVer || (fJsonVer !== -3 && fJsonVer !== -2)) {
          throw new Error(i18nt('designer.hint.jsonVersionMismatch'));
        }

        props.designer.loadFormJson(importObj);

        data.showImportJsonDialogFlag = false;
        $current.$message.success(i18nt('designer.hint.importJsonSuccess'));

        props.designer.emitHistoryChange();

        props.designer.emitEvent('form-json-imported', []);
      } catch (ex) {
        $current.$message.error(ex + '');
      }
    };

    const exportJson = () => {
      let widgetList = deepClone(props.designer.widgetList);
      let formConfig = deepClone(props.designer.formConfig);
      data.jsonContent = JSON.stringify({ formConfig, widgetList }, null, '  ');
      data.jsonRawContent = JSON.stringify({ formConfig, widgetList });
      data.showExportJsonDialogFlag = true;
    };

    const copyFormJson = e => {
      copyToClipboard(data.jsonRawContent, e, $current.$message, i18nt('designer.hint.copyJsonSuccess'), i18nt('designer.hint.copyJsonFail'));
    };

    const saveFormJson = () => {
      saveAsFile(data.jsonContent, `vform${generateId()}.json`);
    };

    const exportCode = () => {
      data.vueCode = generateCode(formJson.value);
      data.htmlCode = generateCode(formJson.value, 'html');
      data.showExportCodeDialogFlag = true;
    };

    const copyVueCode = e => {
      copyToClipboard(data.vueCode, e, $current.$message, i18nt('designer.hint.copyVueCodeSuccess'), i18nt('designer.hint.copyVueCodeFail'));
    };

    const copyHtmlCode = e => {
      copyToClipboard(data.htmlCode, e, $current.$message, i18nt('designer.hint.copyHtmlCodeSuccess'), i18nt('designer.hint.copyHtmlCodeFail'));
    };

    const saveVueCode = () => {
      saveAsFile(data.vueCode, `vform${generateId()}.vue`);
    };

    const saveHtmlCode = () => {
      saveAsFile(data.htmlCode, `vform${generateId()}.html`);
    };

    const generateSFC = () => {
      loadBeautifier(beautifier => {
        data.sfcCode = genSFC(props.designer.formConfig, props.designer.widgetList, beautifier);
        data.sfcCodeV3 = genSFC(props.designer.formConfig, props.designer.widgetList, beautifier, true);
        data.showExportSFCDialogFlag = true;
      });
    };

    const copyV2SFC = e => {
      copyToClipboard(data.sfcCode, e, $current.$message, i18nt('designer.hint.copySFCSuccess'), i18nt('designer.hint.copySFCFail'));
    };

    const copyV3SFC = e => {
      copyToClipboard(data.sfcCodeV3, e, $current.$message, i18nt('designer.hint.copySFCSuccess'), i18nt('designer.hint.copySFCFail'));
    };

    const saveV2SFC = () => {
      saveAsFile(data.sfcCode, `vformV2-${generateId()}.vue`);
    };

    const saveV3SFC = () => {
      saveAsFile(data.sfcCodeV3, `vformV3-${generateId()}.vue`);
    };

    const getFormData = () => {
      preForm.value
        .getFormData()
        .then(formData => {
          data.formDataJson = JSON.stringify(formData, null, '  ');
          data.formDataRawJson = JSON.stringify(formData);

          data.showFormDataDialogFlag = true;
        })
        .catch(error => {
          console.log(error);
          $current.$message.error(error);
        });
    };

    const copyFormDataJson = e => {
      copyToClipboard(data.formDataRawJson, e, $current.$message, i18nt('designer.hint.copyJsonSuccess'), i18nt('designer.hint.copyJsonFail'));
    };

    const saveFormData = () => {
      saveAsFile(data.formDataJson, `formData${generateId()}.json`);
    };

    const resetForm = () => {
      preForm.value.resetForm();
    };

    const setFormDisabled = () => {
      preForm.value.disableForm();
    };

    const setFormEnabled = () => {
      preForm.value.enableForm();
    };

    const switchReadMode = () => {
      data.formReadonlyFlag = !data.formReadonlyFlag;
      preForm.value.setReadMode(data.formReadonlyFlag);
    };

    const testSetFormJson = () => {
      // let newJson = {"widgetList":[{"key":106933,"type":"input","icon":"text-field","formItemFlag":true,"options":{"name":"input40302","label":"input-new","labelAlign":"","type":"text","defaultValue":"","placeholder":"","columnWidth":"200px","size":"","labelWidth":null,"labelHidden":false,"readonly":false,"disabled":false,"hidden":false,"clearable":true,"showPassword":false,"required":false,"validation":"","validationHint":"","customClass":[],"labelIconClass":null,"labelIconPosition":"rear","labelTooltip":null,"minLength":null,"maxLength":null,"showWordLimit":false,"prefixIcon":"","suffixIcon":"","appendButton":false,"appendButtonDisabled":false,"buttonIcon":"custom-search","onCreated":"","onMounted":"","onInput":"","onChange":"","onFocus":"","onBlur":"","onValidate":""},"id":"input40302"}],"formConfig":{"modelName":"formData","refName":"vForm","rulesName":"rules","labelWidth":120,"labelPosition":"left","size":"","labelAlign":"label-left-align","cssCode":"","customClass":[],"functions":"","layoutType":"PC","jsonVersion":3,"onFormCreated":"","onFormMounted":"","onFormDataChange":""}}
      let newJson = {
        formConfig: {
          colon: false,
          cssCode: '',
          customClass: [],
          dataSources: [],
          functions: '',
          inputAlign: 'left',
          jsonVersion: -2,
          labelAlign: 'left',
          labelPosition: 'left',
          labelWidth: 80,
          layoutType: 'H5',
          modelName: 'formData',
          onFormCreated: '',
          onFormDataChange: '',
          onFormMounted: '',
          refName: 'vForm',
          rulesName: 'rules',
          size: '',
        },
        widgetList: [
          {
            category: 'container',
            icon: 'cell-group',
            id: 'mcellgroup99507',
            key: 101486,
            options: {
              border: true,
              customClass: [],
              hidden: false,
              label: 'group',
              name: 'mcellgroup99507',
            },
            type: 'm-cell-group',
            widgetList: [
              {
                formItemFlag: true,
                icon: 'text-field',
                id: 'minput58973',
                key: 35504,
                options: {
                  appendButton: false,
                  appendButtonDisabled: false,
                  appendButtonIcon: 'search',
                  appendButtonLabel: '',
                  appendButtonType: 'primary',
                  clearable: true,
                  customClass: [],
                  defaultValue: '',
                  disabled: false,
                  hidden: false,
                  inputAlign: 'left',
                  label: 'm-input',
                  labelAlign: '',
                  labelHidden: false,
                  labelWidth: null,
                  leftIcon: '',
                  maxLength: null,
                  name: 'minput58973',
                  onAppendButtonClick: '',
                  onBlur: '',
                  onCreated: '',
                  onFocus: '',
                  onInput: '',
                  onMounted: '',
                  onValidate: '',
                  placeholder: '',
                  readonly: false,
                  required: false,
                  requiredHint: '',
                  rightIcon: '',
                  showWordLimit: false,
                  size: '',
                  type: 'text',
                  validation: '',
                  validationHint: '',
                },
                type: 'm-input',
              },
              {
                formItemFlag: true,
                icon: 'textarea-field',
                id: 'mtextarea90485',
                key: 92891,
                options: {
                  customClass: '',
                  defaultValue: '',
                  disabled: false,
                  hidden: false,
                  inputAlign: 'left',
                  label: 'm-textarea',
                  labelAlign: '',
                  labelHidden: false,
                  labelWidth: null,
                  maxLength: null,
                  name: 'mtextarea90485',
                  onBlur: '',
                  onCreated: '',
                  onFocus: '',
                  onInput: '',
                  onMounted: '',
                  onValidate: '',
                  placeholder: '',
                  readonly: false,
                  required: false,
                  requiredHint: '',
                  rows: 3,
                  showWordLimit: false,
                  size: '',
                  validation: '',
                  validationHint: '',
                },
                type: 'm-textarea',
              },
            ],
          },
          {
            category: 'container',
            cols: [
              {
                category: 'container',
                icon: 'grid-col',
                id: 'm-grid-col-75217',
                internal: true,
                options: {
                  customClass: '',
                  hidden: false,
                  name: 'mGridCol75217',
                  offset: 0,
                  span: 12,
                },
                type: 'm-grid-col',
                widgetList: [
                  {
                    formItemFlag: true,
                    icon: 'number-field',
                    id: 'mnumber112354',
                    key: 31332,
                    options: {
                      closeButtonText: '',
                      customClass: [],
                      defaultValue: '',
                      disabled: false,
                      hidden: false,
                      label: 'm-number',
                      labelAlign: '',
                      labelHidden: false,
                      labelWidth: null,
                      name: 'mnumber112354',
                      onBlur: '',
                      // labelIconClass: null,
                      // labelIconPosition: 'rear',
                      // labelTooltip: null,
                      onCreated: '',
                      onFocus: '',
                      onInput: '',
                      onMounted: '',
                      onValidate: '',
                      placeholder: '',
                      readonly: false,
                      required: false,
                      requiredHint: '',
                      size: '',
                      validation: '',
                      validationHint: '',
                    },
                    type: 'm-number',
                  },
                ],
              },
              {
                category: 'container',
                icon: 'grid-col',
                id: 'm-grid-col-20640',
                internal: true,
                options: {
                  customClass: '',
                  hidden: false,
                  name: 'mGridCol20640',
                  offset: 0,
                  span: 12,
                },
                type: 'm-grid-col',
                widgetList: [
                  {
                    formItemFlag: true,
                    icon: 'stepper-field',
                    id: 'mstepper95512',
                    key: 39476,
                    options: {
                      customClass: '',
                      defaultValue: '1',
                      disabled: false,
                      hidden: false,
                      label: 'm-stepper',
                      labelAlign: '',
                      labelHidden: false,
                      labelWidth: null,
                      max: 100000000000,
                      // labelIconClass: null,
                      // labelIconPosition: 'rear',
                      // labelTooltip: null,
                      min: -100000000000,
                      name: 'mstepper95512',
                      onBlur: '',
                      onChange: '',
                      onCreated: '',
                      onFocus: '',
                      onMounted: '',
                      onValidate: '',
                      placeholder: '',
                      precision: 0,
                      readonly: false,
                      step: 1,
                      stepButtonSize: '28',
                      validation: '',
                      validationHint: '',
                    },
                    type: 'm-stepper',
                  },
                ],
              },
            ],
            icon: 'grid',
            id: 'mgrid63789',
            key: 37579,
            options: {
              colHeight: null,
              customClass: [],
              gutter: 12,
              hidden: false,
              name: 'mgrid63789',
            },
            type: 'm-grid',
          },
          {
            category: 'container',
            icon: 'tab',
            id: 'mtab88160',
            key: 43279,
            options: {
              active: '',
              colorStyle: '#B0B0B0',
              customClass: [],
              displayType: 'border-card',
              hidden: false,
              name: 'mtab88160',
              textEllipsis: true,
            },
            tabs: [
              {
                category: 'container',
                icon: 'tab-pane',
                id: 'm-tab-pane-40686',
                internal: true,
                options: {
                  active: false,
                  customClass: '',
                  disabled: false,
                  hidden: false,
                  label: 'tab 1',
                  name: 'tab1',
                },
                type: 'm-tab-pane',
                widgetList: [
                  {
                    formItemFlag: true,
                    icon: 'radio-field',
                    id: 'mradio41076',
                    key: 70588,
                    options: {
                      customClass: [],
                      defaultValue: null,
                      direction: 'horizontal',
                      disabled: false,
                      dsEnabled: false,
                      dsName: '',
                      hidden: false,
                      iconSize: '20',
                      label: 'm-radio',
                      labelAlign: '',
                      labelHidden: false,
                      labelKey: 'label',
                      labelWidth: null,
                      name: 'mradio41076',
                      onChange: '',
                      // labelIconClass: null,
                      // labelIconPosition: 'rear',
                      // labelTooltip: null,
                      onCreated: '',
                      onMounted: '',
                      onValidate: '',
                      optionItems: [
                        {
                          label: 'radio 1',
                          value: 1,
                        },
                        {
                          label: 'radio 2',
                          value: 2,
                        },
                        {
                          label: 'radio 3',
                          value: 3,
                        },
                      ],
                      readonly: false,
                      required: false,
                      requiredHint: '',
                      valueKey: 'value',
                    },
                    type: 'm-radio',
                  },
                ],
              },
              {
                category: 'container',
                icon: 'tab-pane',
                id: 'm-tab-pane-62937',
                internal: true,
                options: {
                  active: false,
                  customClass: '',
                  disabled: false,
                  hidden: false,
                  label: 'tab 2',
                  name: 'm-tab-pane-62937',
                },
                type: 'm-tab-pane',
                widgetList: [
                  {
                    formItemFlag: true,
                    icon: 'checkbox-field',
                    id: 'mcheckbox116151',
                    key: 40747,
                    options: {
                      customClass: [],
                      defaultValue: [],
                      direction: 'horizontal',
                      disabled: false,
                      dsEnabled: false,
                      dsName: '',
                      hidden: false,
                      iconSize: '20',
                      label: 'm-checkbox',
                      labelAlign: '',
                      labelHidden: false,
                      labelKey: 'label',
                      labelWidth: null,
                      name: 'mcheckbox116151',
                      onChange: '',
                      // labelIconClass: null,
                      // labelIconPosition: 'rear',
                      // labelTooltip: null,
                      onCreated: '',
                      onMounted: '',
                      onValidate: '',
                      optionItems: [
                        {
                          label: 'check 1',
                          value: 1,
                        },
                        {
                          label: 'check 2',
                          value: 2,
                        },
                        {
                          label: 'check 3',
                          value: 3,
                        },
                      ],
                      readonly: false,
                      required: false,
                      requiredHint: '',
                      valueKey: 'value',
                    },
                    type: 'm-checkbox',
                  },
                ],
              },
              {
                category: 'container',
                icon: 'tab-pane',
                id: 'm-tab-pane-55182',
                internal: true,
                options: {
                  active: false,
                  customClass: '',
                  disabled: false,
                  hidden: false,
                  label: 'tab 3',
                  name: 'm-tab-pane-55182',
                },
                type: 'm-tab-pane',
                widgetList: [
                  {
                    formItemFlag: true,
                    icon: 'select-field',
                    id: 'mselect85689',
                    key: 67839,
                    options: {
                      customClass: [],
                      defaultValue: '',
                      disabled: false,
                      dsEnabled: false,
                      dsName: '',
                      hidden: false,
                      label: 'm-select',
                      labelAlign: '',
                      labelHidden: false,
                      labelKey: 'label',
                      labelWidth: null,
                      name: 'mselect85689',
                      onChange: '',
                      // labelIconClass: null,
                      // labelIconPosition: 'rear',
                      // labelTooltip: null,
                      onCreated: '',
                      onMounted: '',
                      onValidate: '',
                      optionItems: [
                        {
                          label: 'select 1',
                          value: 1,
                        },
                        {
                          label: 'select 2',
                          value: 2,
                        },
                        {
                          label: 'select 3',
                          value: 3,
                        },
                      ],
                      placeholder: '',
                      readonly: false,
                      required: false,
                      requiredHint: '',
                      size: '',
                      valueKey: 'value',
                    },
                    type: 'm-select',
                  },
                ],
              },
            ],
            type: 'm-tab',
          },
          {
            category: 'container',
            icon: 'grid-sub-form',
            id: 'msubform56393',
            key: 64153,
            options: {
              actionColumnPosition: 'left',
              customClass: [],
              hidden: false,
              name: 'msubform56393',
              onSubFormRowAdd: '',
              onSubFormRowChange: '',
              onSubFormRowDelete: '',
              onSubFormRowInsert: '',
              showBlankRow: true,
              showRowNumber: true,
            },
            type: 'm-sub-form',
            widgetList: [
              {
                formItemFlag: true,
                icon: 'date-field',
                id: 'mcalendar60622',
                key: 58478,
                options: {
                  clearable: true,
                  customClass: [],
                  defaultValue: null,
                  disabled: false,
                  editable: false,
                  format: 'YYYY-MM-DD',
                  hidden: false,
                  label: 'm-calendar',
                  labelAlign: '',
                  labelHidden: false,
                  labelWidth: null,
                  maxDate: '',
                  minDate: '',
                  name: 'mcalendar60622',
                  onConfirm: '',
                  // labelIconClass: null,
                  // labelIconPosition: 'rear',
                  // labelTooltip: null,
                  onCreated: '',
                  onMounted: '',
                  onValidate: '',
                  placeholder: '',
                  readonly: false,
                  required: false,
                  requiredHint: '',
                  size: '',
                  validation: '',
                  validationHint: '',
                },
                type: 'm-calendar',
              },
              {
                formItemFlag: true,
                icon: 'date-field',
                id: 'mdate83079',
                key: 99211,
                options: {
                  clearable: true,
                  customClass: '',
                  defaultValue: null,
                  disabled: false,
                  editable: false,
                  format: 'YYYY-MM-DD',
                  hidden: false,
                  label: 'm-date',
                  labelAlign: '',
                  labelHidden: false,
                  labelWidth: null,
                  maxDate: '',
                  minDate: '',
                  name: 'mdate83079',
                  onConfirm: '',
                  // labelIconClass: null,
                  // labelIconPosition: 'rear',
                  // labelTooltip: null,
                  onCreated: '',
                  onMounted: '',
                  onValidate: '',
                  placeholder: '',
                  readonly: false,
                  required: false,
                  requiredHint: '',
                  size: '',
                  validation: '',
                  validationHint: '',
                },
                type: 'm-date',
              },
              {
                formItemFlag: true,
                icon: 'datetime-field',
                id: 'mdatetime109357',
                key: 14312,
                options: {
                  clearable: true,
                  customClass: '',
                  defaultValue: null,
                  disabled: false,
                  editable: false,
                  format: 'YYYY-MM-DD HH:mm',
                  hidden: false,
                  label: 'm-datetime',
                  labelAlign: '',
                  labelHidden: false,
                  labelWidth: null,
                  maxDate: '',
                  minDate: '',
                  name: 'mdatetime109357',
                  onConfirm: '',
                  // labelIconClass: null,
                  // labelIconPosition: 'rear',
                  // labelTooltip: null,
                  onCreated: '',
                  onMounted: '',
                  onValidate: '',
                  placeholder: '',
                  readonly: false,
                  required: false,
                  requiredHint: '',
                  size: '',
                  validation: '',
                  validationHint: '',
                },
                type: 'm-datetime',
              },
            ],
          },
          {
            formItemFlag: false,
            icon: 'divider',
            id: 'mdivider68182',
            key: 103788,
            options: {
              contentPosition: 'center',
              customClass: '',
              dashed: false,
              hidden: false,
              label: 'm-divider',
              name: 'mdivider68182',
              onCreated: '',
              onMounted: '',
            },
            type: 'm-divider',
          },
          {
            category: 'container',
            icon: 'card',
            id: 'collapse40486',
            key: 61253,
            options: {
              accordion: true,
              border: true,
              customClass: [],
              defaultValue: '',
              expandName: 'collapse-item-47571',
              hidden: false,
              label: 'collapse',
              name: 'collapse40486',
            },
            type: 'collapse',
            widgetList: [
              {
                category: 'container',
                icon: 'card',
                id: 'collapse-item-107387',
                internal: true,
                options: {
                  border: true,
                  disabled: false,
                  expand: true,
                  icon: '',
                  'is-link': true,
                  label: 'collapse-item-1',
                  'label-class': '',
                  'lazy-render': false,
                  name: 'collapse-item-107387',
                  readonly: false,
                  size: '',
                  title: 'collapseItem1',
                  'title-class': '',
                  value: '',
                  'value-class': '',
                },
                type: 'collapse-item',
                widgetList: [
                  {
                    formItemFlag: true,
                    icon: 'switch-field',
                    id: 'mswitch79739',
                    key: 78149,
                    options: {
                      activeColor: null,
                      activeText: '',
                      activeValue: true,
                      customClass: [],
                      defaultValue: false,
                      disabled: false,
                      hidden: false,
                      inactiveColor: null,
                      inactiveText: '',
                      inactiveValue: false,
                      label: 'm-switch',
                      labelAlign: '',
                      labelHidden: false,
                      labelWidth: null,
                      name: 'mswitch79739',
                      onChange: '',
                      onCreated: '',
                      onMounted: '',
                      onValidate: '',
                      readonly: false,
                      // labelIconClass: null,
                      // labelIconPosition: 'rear',
                      // labelTooltip: null,
                      switchSize: 24,
                    },
                    type: 'm-switch',
                  },
                  {
                    formItemFlag: true,
                    icon: 'rate-field',
                    id: 'mrate68123',
                    key: 22064,
                    options: {
                      allowHalf: false,
                      customClass: '',
                      defaultValue: 0,
                      disabled: false,
                      hidden: false,
                      label: 'm-rate',
                      labelAlign: '',
                      labelHidden: false,
                      labelWidth: null,
                      // labelIconClass: null,
                      // labelIconPosition: 'rear',
                      // labelTooltip: null,
                      max: 5,
                      name: 'mrate68123',
                      onChange: '',
                      onCreated: '',
                      onMounted: '',
                      onValidate: '',
                      readonly: false,
                      required: false,
                      requiredHint: '',
                      showScore: false,
                      validation: '',
                      validationHint: '',
                    },
                    type: 'm-rate',
                  },
                  {
                    formItemFlag: true,
                    icon: 'slider-field',
                    id: 'mslider94337',
                    key: 56486,
                    options: {
                      customClass: '',
                      defaultValue: null,
                      disabled: false,
                      height: null,
                      hidden: false,
                      label: 'm-slider',
                      labelAlign: '',
                      labelHidden: false,
                      labelWidth: null,
                      max: 100,
                      // labelIconClass: null,
                      // labelIconPosition: 'rear',
                      // labelTooltip: null,
                      min: 0,
                      name: 'mslider94337',
                      onChange: '',
                      onCreated: '',
                      onMounted: '',
                      onValidate: '',
                      range: false,
                      readonly: false,
                      size: '',
                      step: 10,
                      validation: '',
                      validationHint: '',
                    },
                    type: 'm-slider',
                  },
                ],
              },
              {
                category: 'container',
                icon: 'card',
                id: 'collapse-item-47571',
                internal: true,
                options: {
                  border: true,
                  disabled: false,
                  expand: true,
                  icon: '',
                  'is-link': true,
                  label: 'collapse-item-2',
                  'label-class': '',
                  'lazy-render': false,
                  name: 'collapse-item-47571',
                  readonly: false,
                  size: '',
                  title: 'collapseItem2',
                  'title-class': '',
                  value: '',
                  'value-class': '',
                },
                type: 'collapse-item',
                widgetList: [
                  {
                    formItemFlag: false,
                    icon: 'html-text',
                    id: 'mhtmltext27837',
                    key: 52521,
                    options: {
                      customClass: '',
                      hidden: false,
                      htmlContent: '<b>html text</b>',
                      label: 'm-html-text',
                      name: 'mhtmltext27837',
                      onCreated: '',
                      onMounted: '',
                    },
                    type: 'm-html-text',
                  },
                  {
                    formItemFlag: false,
                    icon: 'static-text',
                    id: 'mstatictext17925',
                    key: 104760,
                    options: {
                      customClass: [],
                      fontSize: '13px',
                      hidden: false,
                      label: 'm-static-text',
                      name: 'mstatictext17925',
                      onCreated: '',
                      onMounted: '',
                      textContent: 'static text',
                    },
                    type: 'm-static-text',
                  },
                ],
              },
            ],
          },
          {
            formItemFlag: true,
            icon: 'picture-upload-field',
            id: 'mpictureupload20399',
            key: 16673,
            options: {
              customClass: '',
              customRule: '',
              customRuleHint: '',
              disabled: false,
              fileMaxSize: 5,
              fileTypes: ['jpg', 'jpeg', 'png'],
              hidden: false,
              label: 'm-picture-upload',
              labelAlign: '',
              labelHidden: false,
              labelWidth: null,
              limit: 3,
              multipleSelect: false,
              name: 'mpictureupload20399',
              onBeforeUpload: '',
              // labelIconClass: null,
              // labelIconPosition: 'rear',
              // labelTooltip: null,
              onCreated: '',
              onFileRemove: '',
              onMounted: '',
              onUploadError: '',
              onUploadSuccess: '',
              onValidate: '',
              required: false,
              requiredHint: '',
              uploadTip: '',
              uploadURL: '',
              withCredentials: false,
            },
            type: 'm-picture-upload',
          },
          {
            formItemFlag: true,
            icon: 'file-upload-field',
            id: 'mfileupload82251',
            key: 7358,
            options: {
              customClass: '',
              customRule: '',
              customRuleHint: '',
              disabled: false,
              fileMaxSize: 5,
              fileTypes: ['doc', 'docx', 'xls', 'xlsx'],
              hidden: false,
              label: 'm-file-upload',
              labelAlign: '',
              labelHidden: false,
              labelWidth: null,
              limit: 3,
              multipleSelect: false,
              name: 'mfileupload82251',
              onBeforeUpload: '',
              // labelIconClass: null,
              // labelIconPosition: 'rear',
              // labelTooltip: null,
              onCreated: '',
              onFileRemove: '',
              onMounted: '',
              onUploadError: '',
              onUploadSuccess: '',
              onValidate: '',
              required: false,
              requiredHint: '',
              uploadButtonText: '',
              uploadTip: '',
              uploadURL: '',
              withCredentials: false,
            },
            type: 'm-file-upload',
          },
          {
            formItemFlag: false,
            icon: 'alert',
            id: 'alert44180',
            key: 104406,
            options: {
              closable: true,
              customClass: '',
              hidden: false,
              label: 'alert',
              name: 'alert44180',
              onClose: '',
              showIcon: false,
              title: 'Good things are coming...',
              type: 'info',
            },
            type: 'alert',
          },
          {
            formItemFlag: false,
            icon: 'button',
            id: 'mbutton57786',
            key: 38124,
            options: {
              customClass: '',
              disabled: false,
              displayStyle: 'block',
              hidden: false,
              icon: null,
              label: 'm-button',
              name: 'mbutton57786',
              onClick: '',
              onCreated: '',
              onMounted: '',
              plain: false,
              round: false,
              size: 'normal',
              type: 'default',
            },
            type: 'm-button',
          },
        ],
      };

      // let newJson = {"widgetList":[{"key":70118,"type":"input","icon":"text-field","formItemFlag":true,"options":{"name":"input37241","label":"input","labelAlign":"","type":"text","defaultValue":"","placeholder":"","columnWidth":"200px","size":"","labelWidth":null,"labelHidden":false,"readonly":false,"disabled":false,"hidden":false,"clearable":true,"showPassword":false,"required":false,"validation":"","validationHint":"","customClass":[],"labelIconClass":null,"labelIconPosition":"rear","labelTooltip":null,"minLength":null,"maxLength":null,"showWordLimit":false,"prefixIcon":"","suffixIcon":"","appendButton":false,"appendButtonDisabled":false,"buttonIcon":"custom-search","onCreated":"","onMounted":"","onInput":"","onChange":"","onFocus":"","onBlur":"","onValidate":""},"id":"input37241"}],"formConfig":{"modelName":"formData","refName":"vForm","rulesName":"rules","labelWidth":150,"labelPosition":"left","size":"","labelAlign":"label-right-align","cssCode":"","customClass":"","functions":"","layoutType":"PC","jsonVersion":3,"onFormCreated":"","onFormMounted":"","onFormDataChange":""}}
      preForm.value.setFormJson(newJson);
    };

    const testSubFormHide = () => {
      preForm.value.hideWidgets('input73220');
    };

    const testSetFormData = () => {
      let testFormData = {
        mcheckbox116151: [2, 3],
        mfileupload82251: null,
        minput58973: '1',
        mnumber112354: 5,
        mpictureupload20399: null,
        mradio41076: 1,
        mrate68123: 3,
        mselect85689: '',
        mslider94337: 30,
        mstepper95512: '4',
        msubform56393: [{ mcalendar60622: '2023-02-16', mdate83079: null, mdatetime109357: null }],
        mswitch79739: true,
        mtextarea90485: '2',
      };

      testFormData = {
        mcalendar63942: '2014-02-13',
        mdate87076: '2012年04月12日',
        mdaterange21904: ['2024-03-22', '2024-04-02'],
        mdatetime101033: '2014年10月07日 09时09分',
        mtime42442: '12:07:08 AM',
      };
      preForm.value.setFormData(testFormData);
    };

    const handleFormChange = (fieldName, newValue, oldValue, formModel) => {
      /*
        console.log('---formChange start---')
        console.log('fieldName', fieldName)
        console.log('newValue', newValue)
        console.log('oldValue', oldValue)
        console.log('formModel', formModel)
        console.log('---formChange end---')
        */
    };

    const testOnAppendButtonClick = clickedWidget => {
      // console.log('test', clickedWidget);
    };

    const testOnButtonClick = button => {
      console.log('test', button);
    };

    const testDTSC = (dt, s1, s2) => {
      // console.log('test dt', dt);
      // console.log('test s1', s1);
      // console.log('test s2', s2);
    };

    const testOBC = aa => {
      // console.log('test=====', aa);
    };

    const onMyEmitTest = aaa => {
      // console.log('test emit', aaa);
    };

    const findWidgetById = wId => {
      let foundW = null;
      traverseAllWidgets(props.designer.widgetList, w => {
        if (w.id === wId) {
          foundW = w;
        }
      });

      return foundW;
    };

    const onNodeTreeClick = (nodeData, node, nodeEl) => {
      // console.log('test', JSON.stringify(nodeData))

      if (nodeData.selectable !== undefined && !nodeData.selectable) {
        $current.$message.info(i18nt('designer.hint.currentNodeCannotBeSelected'));
      } else {
        const selectedId = nodeData.id;
        const foundW = findWidgetById(selectedId);
        if (foundW) {
          props.designer.setSelected(foundW);
        }
      }
    };

    return {
      i18nt,

      ...toRefs(data),
      buildTreeNodeOfWidget,
      changeLayoutType,
      clearFormWidget,
      copyFormDataJson,
      copyFormJson,
      copyHtmlCode,
      copyV2SFC,
      copyV3SFC,
      copyVueCode,
      designerDsv,
      doJsonImport,

      exportCode,
      exportJson,

      findWidgetById,

      /* 计算属性 */
      formJson,
      generateSFC,

      getFormData,

      handleFormChange,
      importJson,
      layoutType,
      /* 页面组件 */
      nodeTree,
      onMyEmitTest,
      onNodeTreeClick,
      preForm,
      previewForm,
      redoDisabled,
      redoHistory,
      refreshNodeTree,
      resetForm,
      saveAsFile,
      saveFormData,
      saveFormJson,

      saveHtmlCode,
      saveV2SFC,
      saveV3SFC,
      saveVueCode,
      setFormDisabled,
      setFormEnabled,

      showNodeTreeDrawer,

      /* 方法 */
      showToolButton,
      switchReadMode,
      testDTSC,
      testOBC,
      testOnAppendButtonClick,
      testOnButtonClick,
      testSetFormData,

      // 测试的方法
      testSetFormJson,
      testSubFormHide,
      undoDisabled,
      undoHistory,
    };
  },
};
</script>

<style lang="scss" scoped>
div.toolbar-container {
  //min-width: 728px;  /* 解决工具按钮栏换行的问题！！ */
  /* 上一行css有问题，当窗口宽度不足时会把按钮挤出到右边的属性设置区，弃之！ */
}

.left-toolbar {
  display: flex;
  margin-top: 4px;
  float: left;
  font-size: 16px;
}

.right-toolbar {
  line-height: 42px;
  text-align: right;
  overflow: hidden;

  .right-toolbar-con {
    display: inline-block;
    text-align: left;
  }

  :deep(.el-button) {
    margin-left: 10px;
  }

  :deep(.el-button--text) {
    font-size: 14px !important;
  }

  :deep(.svg-icon) {
    margin-left: 0;
    margin-right: 0.05em;
  }
}

.el-button i {
  margin-right: 3px;
}

.small-padding-dialog {
  :deep(.el-dialog__header) {
    //padding-top: 3px;
    //padding-bottom: 3px;
    background: #f1f2f3;
  }

  :deep(.el-dialog__body) {
    padding: 12px 15px 12px 15px;

    .el-alert.alert-padding {
      padding: 0 10px;
    }
  }

  :deep(.ace-container) {
    border: 1px solid #dcdfe6;
  }
}

.dialog-title-light-bg {
  :deep(.el-dialog__header) {
    background: #f1f2f3;
  }
}

.no-box-shadow {
  box-shadow: none;
}

.no-padding.el-tabs--border-card {
  :deep(.el-tabs__content) {
    padding: 0;
  }
}

.form-render-wrapper {
  //height: calc(100vh - 142px);
  //all: revert !important; /* 防止表单继承el-dialog等外部样式，未生效，原因不明？？ */
}

.form-render-wrapper.h5-layout {
  margin: 0 auto;
  width: 420px;
  border-radius: 15px;
  //border-width: 10px;
  box-shadow: 0 0 1px 10px #495060;
  height: calc(100vh - 175px);
  overflow-y: auto;
  overflow-x: hidden;
}

.form-render-wrapper.pad-layout {
  margin: 0 auto;
  width: 960px;
  border-radius: 15px;
  //border-width: 10px;
  box-shadow: 0 0 1px 10px #495060;
  height: calc(100vh - 175px);
  overflow-y: auto;
  overflow-x: hidden;
}

.node-tree-drawer {
  :deep(.el-drawer) {
    padding: 10px;
    overflow: auto;
  }

  :deep(.el-drawer__header) {
    margin-bottom: 12px;
    padding: 5px 5px 0;
  }

  :deep(.el-drawer__body) {
    padding-left: 5px;
  }
}

/*.node-tree-scroll-bar {*/
/*  height: 100%;*/
/*  overflow: auto;*/
/*}*/

.node-tree :deep() {
  .el-tree > .el-tree-node:after {
    border-top: none;
  }
  .el-tree-node {
    position: relative;
    padding-left: 12px;
  }

  .el-tree-node__content {
    padding-left: 0 !important;
  }

  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .el-tree-node__children {
    padding-left: 12px;
    overflow: visible !important; /* 加入此行让el-tree宽度自动撑开，超出宽度el-draw自动出现水平滚动条！ */
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node:before {
    content: '';
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: '';
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px dashed #4386c6;
    bottom: 0px;
    height: 100%;
    top: -10px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px dashed #4386c6;
    height: 20px;
    top: 12px;
    width: 16px;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #c2d6ea !important;
  }

  .el-tree-node__expand-icon {
    margin-left: -3px;
    padding: 6px 6px 6px 0px;
    font-size: 16px;
  }
}
</style>
